import { render, staticRenderFns } from "./interactive-services-create.vue?vue&type=template&id=3b5c9afc&"
import script from "./interactive-services-create.vue?vue&type=script&lang=js&"
export * from "./interactive-services-create.vue?vue&type=script&lang=js&"
import style0 from "./interactive-services-create.vue?vue&type=style&index=0&id=3b5c9afc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports